'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LocaleLabel;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function LocaleLabel(_ref) {
  var locale = _ref.locale,
      possibleLocales = _ref.possibleLocales;

  if (locale === 'library') {
    return _react2.default.createElement(
      'span',
      { className: 'cp-locale-label' },
      _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'your_library' })
    );
  }

  return _react2.default.createElement(
    'span',
    { className: 'cp-locale-label' },
    possibleLocales.get(locale)
  );
}

LocaleLabel.propTypes = {
  locale: _react.PropTypes.string,
  possibleLocales: _reactImmutableProptypes2.default.mapOf(_react.PropTypes.string)
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/locale-label/components/LocaleLabel.component.js
// module id = 1319
// module chunks = 0